import React from 'react';

import { DisplayStyle } from 'components/common/ToggleView/ToggleView';

import { IHashmapTable } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

type sortBy = {
    id: string;
    desc?: true;
};

export interface IVersionCompareTableConfigProps {
    componentKey: keyof IHashmapTable;
    apiName: string;
    isFetched: boolean;
    key: string;
    sortBy: sortBy[];
    pptxSortBy?: { key: string; sortOrder: string };
    hiddenColumns?: {
        [key in DisplayStyle]: string[];
    };
    noData: React.FC;
}

export interface IVersionCompareTableConfig {
    'version-compare-tracked-activities': IVersionCompareTableConfigProps;
    'summary-tracked-activities': IVersionCompareTableConfigProps;
    'tracked-portfolio-activities': IVersionCompareTableConfigProps;
    'status-changes': IVersionCompareTableConfigProps;
    'start-date-changes': IVersionCompareTableConfigProps;
    'finish-date-changes': IVersionCompareTableConfigProps;
    'largest-duration-variance': IVersionCompareTableConfigProps;
    'largest-float-changes': IVersionCompareTableConfigProps;
    'relationships-type-changes': IVersionCompareTableConfigProps;
    'relationships-count-changes': IVersionCompareTableConfigProps;
    'largest-added-activities': IVersionCompareTableConfigProps;
    'largest-deleted-activities': IVersionCompareTableConfigProps;
    'top-recommendations': IVersionCompareTableConfigProps;
    'key-achievements': IVersionCompareTableConfigProps;
    'activity-predecessors': IVersionCompareTableConfigProps;

    'critical-path-added': IVersionCompareTableConfigProps;
    'critical-path-removed': IVersionCompareTableConfigProps;
}

export const ProgramProgressOverviewQueryKey = [
    'topOverdue',
    'baselineVsActual',
    'getCriticalityWeightScurveGraph',
    'activitiesWeight',
    'milestoneWeight',
    'highLevelProgram',
    'milestone',
    'getStoredTags',
    'getBaselineVsActual',
];
export const ProgramStatusSummaryReportQueryKeys = [
    'useQueryPrioritiesMatrixCards',
    'useQueryGetMatrixData',
    'keyAchievementsDataTable',
    'summaryTrackedActivitiesTableData',
    'getKeyActivities',
    'getStoredTags',
];
export const ProgramCriticalAnalysisQueryKeys = [
    'activities',
    'topDurations',
    'sharedResourcesAvailability',
    'getStoredTags',
];
export const VersionCompareQueryKeys = [
    'versionCompareTrackedActivitieTableData',
    'finishDateChangesTableData',
    'startDateChangesTableData',
    'statusChangesTableData',
    'largestAddedActivitiesTableData',
    'largestDeletedActivitiesTableData',
    'criticalPathAddedTableData',
    'criticalPathRemovedTableData',
    'largestFloatChangesTableData',
    'largestDurationVarianceTableData',
    'relationshipTypeChangesTableData',
    'relationshipCountChangesTableData',
    'getStoredTags',
];
